import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Feed, Icon, Dropdown } from 'semantic-ui-react';

import './style.css';
import EntryGroup from '../EntryGroup';
import UpdatableEntryItem from 'containers/UpdatableEntryItem';

/**
 * [EntriesGrid] - contains all of the groupings
 */
class EntriesGrid extends Component {
  constructor(props) {
    super(props);
    this.renderEntryItem = this.renderEntryItem.bind(this);
    this.renderByGroups = this.renderByGroups.bind(this);
    this.toggleGroupSelected = this.toggleGroupSelected.bind(this);
  }

  toggleGroupSelected = (id, group, shouldSelect) => {
    const { handleSelected, handleUnselected, groupsSelected } = this.props;
    const handler = shouldSelect ? handleSelected : handleUnselected;
    for (let e of group) handler(e.id, e.tags)
    const newGroupsSelected = shouldSelect
        ? [ ...groupsSelected, id ]
        : _.filter(groupsSelected, gid => id !== gid)
    this.props.handleGroupsSelected(newGroupsSelected);
  }

  openEntries = (entries) => {
    const { entriesObj } = this.props;
    for (let { id } of entries) {
      window.open(entriesObj[id].url, '_blank');
    }
    this.props.handleEntriesOpened(_.map(entries, e => e.id), 'entry group button')
  }

  isEntrySelected = (id) => {
    const { entriesSelected } = this.props;
    return _.find(entriesSelected, (eId) => eId === id ) ? true : false;
  }

  renderEntryItem = (entry, header) => {
    const { handleSelected, handleUnselected, EntryItemComponent } = this.props;

    const Component = EntryItemComponent || UpdatableEntryItem;
    return (
      <Component
        key={entry.id}
        entry={entry}
        tags={entry.tags}
        handleSelected={handleSelected}
        handleUnselected={handleUnselected}
        isSelected={this.isEntrySelected(entry.id)}
        hiddenTags={[ header ]}
      />
    );
  }

  renderByGroups = (sections, group, header) => {
    const { sortedByTags } = this.props;
    const section = (
      <EntryGroup
        className={sortedByTags ? 'tags' : ''}
        key={header}
        header={header}
        toggleSelected={(select) => this.toggleGroupSelected(header, group, select)}
        isSelected={this.props.groupsSelected.indexOf(header) >= 0}
        openAll={() => this.openEntries(group)}>
          {group.map((e) => this.renderEntryItem(e, header))}
      </EntryGroup>
    );
    sections.push(section);
    return sections;
  }

  createDropDownItem = ({value, text, icon}, onClick) => {
    const { readFilter } = this.props;
    const active = readFilter === value;
    return (
      <Dropdown.Item
        active={active}
        selected={active}
        key={value}
        value={value}
        onClick={(e, data) => { onClick(data.value) }}>
          { icon && <Icon className={icon} /> }
          { text }
      </Dropdown.Item>
    );
  }

  renderReadButton = () => {
    const { readFilter, handleChangeReadFilter } = this.props;
    const options = [
      { value: 'read', text: 'Read', icon: 'flatico-check-2'},
      { value: 'unread', text: 'Unread', icon: 'flatico-check'},
      { value: '', text: 'Show All'}
    ]
    const textOptions = { read: 'Read', unread: 'Unread', '': 'All'}
    return (
      <Dropdown
        icon='filter'
        button
        basic
        floating
        className='icon'
        labeled
        text={textOptions[readFilter]}>
        <Dropdown.Menu>
          {_.map(options, (o) => {
            return this.createDropDownItem(o, handleChangeReadFilter)
          })}
        </Dropdown.Menu>
      </Dropdown>

      );
  }

  render() {
    const { handleToggleSortOrder, sortedByTags, entryGroups } = this.props;
    return (
      <div className={`entries-grid ${this.props.className}`}>
        <div className="entries-grid-header">
          <Button.Group basic>
            <Button active={sortedByTags} icon='tags'
                onClick={() => !sortedByTags && handleToggleSortOrder()}/>
            <Button active={!sortedByTags} icon='calendar outline'
                onClick={() => sortedByTags && handleToggleSortOrder()}/>
          </Button.Group>
          {this.renderReadButton()}
        </div>
        {
          _.isEmpty(entryGroups)
            ? <div className='null-state no-tags'>
                <div className='header'>
                  Nothing here yet...
                </div>
                <div className='description'>
                  Go find some articles, tabs, podcasts,
                  anything with a url that you'd like to save for later.
                  <a href='/faq'> Need help?</a>
                </div>
              </div>
            : <div className={ !sortedByTags ? 'ui feed timeline' : 'tag groupings'}>
                { _.reduce(entryGroups, this.renderByGroups, [])}
              </div>
        }
      </div>
    );
  }
}

EntriesGrid.propTypes = {
  handleGroupsSelected: PropTypes.func.isRequired,
  handleChangeReadFilter: PropTypes.func.isRequired,
  handleToggleSortOrder: PropTypes.func.isRequired,
  entriesObj: PropTypes.object.isRequired,
  entriesSelected: PropTypes.arrayOf(PropTypes.string.isRequired),
  entryGroups: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.object.isRequired).isRequired),
  showRead: PropTypes.bool,
  sortedByTags: PropTypes.bool,
  handleSelected: PropTypes.func,
  handleUnselected: PropTypes.func
}

EntriesGrid.defaultProps = {
  showRead: false,
  sortedByTags: false,
  entriesSelected: [],
  groupsSelected: []
}


export default EntriesGrid;



// WEBPACK FOOTER //
// ./src/components/EntriesGrid/EntriesGrid.js